import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight } from '@fortawesome/free-regular-svg-icons';
import './Tier1.css';

class Tier1 extends PureComponent {

	constructor(props) {
		super(props);
		const {
			data,
		} = this.props;

		const styles = data.map((cust, idx) => {
			return (
				{
					background: '#FFFFFF',
					color: '#5B6770',
					buttonColor: '#5060F6',
				}
			)
		});

		this.state = {
			styles: styles
		};
	}

	changeBackground(idx, color) {
		const styles = [...this.state.styles];
		styles[idx] = {
			background: color,
			color: '#FFFFFF',
			buttonColor: '#FFFFFF',
		}
		this.setState(Object.assign({}, this.state, {
			styles: styles,
		}));
	}

	changeBackgroundBack(idx) {
		const styles = [...this.state.styles];
		styles[idx] = {
			background: '#FFFFFF',
			color: '#5B6770',
			buttonColor: '#5060F6',
		}
		this.setState(Object.assign({}, this.state, {
			styles: styles,
		}));
	}

	renderCustodians(data) {
		const {
			styles,
		} = this.state;

		const {
			selectItem,
		} = this.props;

		return data.map((cust, idx) => {
			return (
				<div key={idx} className='col-md-3'>
					<div
						className='tier1Box'
						onMouseOver={() => this.changeBackground(idx, cust.color)}
						onMouseOut={() => this.changeBackgroundBack(idx)}
						onClick={() => selectItem(idx)}
						style={{ color: styles[idx].color, background: styles[idx].background }}
					>
						<div style={{ height: '86px', color: styles[idx].color, background: styles[idx].background }}>{cust.name}</div>
						<div style={{ textAlign: 'right', color: styles[idx].buttonColor, background: styles[idx].background }}>
							<FontAwesomeIcon icon={faArrowAltCircleRight} style={{ fontSize: '28px' }} />
						</div>
					</div>
				</div>
			);
		});
	}

	render() {
		const {
			data,
		} = this.props;

		return (
			<div className='row'>
				{this.renderCustodians(data)}
			</div>
		)
	}

}

export default (Tier1);
